import { useState, useEffect } from 'react';
import api from '../../lib/api';
import { Card, CardContent } from '../ui/card';
import { Switch } from '../ui/switch';
import { Badge } from '../ui/badge';
import { Rocket } from 'lucide-react';
import { toast } from 'sonner';
import { useAuth } from '../../lib/auth-context';

export const CoachLaunchToggle = () => {
  const { user } = useAuth();
  const [state, setState] = useState(null);
  const [busy, setBusy] = useState(false);
  const isSuper = user?.role === 'superadmin';

  useEffect(() => {
    api.get('/api/admin/products/coach-launch').then((r) => setState(r.data.public)).catch(() => {});
  }, []);

  const toggle = async (v) => {
    if (!isSuper) return;
    if (v && !window.confirm('Make SoulAI Coach public? Every learner will get the FREE tier (intro + first class, then paywall). Paid users are unaffected.')) return;
    setBusy(true);
    try {
      const r = await api.post('/api/admin/products/coach-launch', { public: v });
      setState(r.data.public);
      toast.success(r.data.public ? 'SoulAI Coach is now PUBLIC (free tier for everyone)' : 'SoulAI Coach back to Coming Soon');
    } catch (err) { toast.error(err.response?.data?.detail || 'Failed to update'); }
    setBusy(false);
  };

  if (state === null) return null;
  return (
    <Card className={`rounded-2xl ${state ? 'border-emerald-200 bg-emerald-50/40' : 'border-amber-200 bg-amber-50/40'}`} data-testid="coach-launch-card">
      <CardContent className="py-3 flex items-center gap-3 flex-wrap">
        <Rocket className={`h-4 w-4 ${state ? 'text-emerald-700' : 'text-amber-700'}`} />
        <div className="flex-1 min-w-[220px]">
          <p className="text-sm font-medium flex items-center gap-2">
            Public launch
            <Badge variant="outline" className={`text-[10px] ${state ? 'bg-emerald-100 text-emerald-800 border-emerald-200' : 'bg-amber-100 text-amber-800 border-amber-200'}`} data-testid="coach-launch-status">
              {state ? 'LIVE — free tier for all learners' : 'Coming Soon (admin toggle / paid only)'}
            </Badge>
          </p>
          <p className="text-xs text-muted-foreground mt-0.5">
            When ON, every learner sees the coach: intro + first class free, then the monthly / till-delivery paywall. Paid & Elite add-on users always have full access.
          </p>
        </div>
        <Switch checked={state} onCheckedChange={toggle} disabled={busy || !isSuper} data-testid="coach-launch-switch" />
      </CardContent>
    </Card>
  );
};
